import { Box, Tabs, TabList, TabPanels, TabPanel, Tab } from '@chakra-ui/react'
import { DataConfig } from '../components/config'
import { DigitalTwinsConfig } from '../components/config'
import { CodeConfig } from '../components/config'
import { ModelConfig } from '../components/config/'
import { GeometryConfig } from '../components/config/'

export const Config = () => {
  const tabs = [
    { label: 'Data', content: <DataConfig /> },
    { label: 'Digital Twins', content: <DigitalTwinsConfig /> },
    { label: 'Models', content: <ModelConfig /> },
    { label: 'Geometries', content: <GeometryConfig /> },
    { label: 'Code', content: <CodeConfig /> },
  ]

  return (
    <Box p={4}>
      <Tabs 
        variant="enclosed" 
        colorScheme="blue"
      >
        <TabList 
          borderBottom="none"
          sx={{
            '& .chakra-tabs__tab': {
              borderBottom: '1px solid transparent',
              transition: 'none',
            },
            '& .chakra-tabs__tab[aria-selected=true]': {
              borderBottomColor: 'white',
              borderBottom: '1px solid white',
            },
            '& .chakra-tabs__tab:not([aria-selected=true]):hover': {
              borderBottom: '1px solid transparent',
            }
          }}
        >
          {tabs.map((tab, index) => (
            <Tab 
              key={index} 
              _selected={{ 
                bg: 'white', 
                borderBottom: '1px solid white',
                mb: '-1px',
              }}
            >
              {tab.label}
            </Tab>
          ))}
        </TabList>
        <TabPanels 
          bg="white" 
          borderX="1px" 
          borderBottom="1px" 
          borderColor="white"
        >
          {tabs.map((tab, index) => (
            <TabPanel key={index}>
              {tab.content}
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </Box>
  )
}
